import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { OnboardEmployeePassportVisaInfo } from "../../shared/models/OnboardEmployeePassportVisaInfo";
import { FormGroup, FormControl, FormArray, FormBuilder } from "@angular/forms";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material";
import { ToastrService } from "ngx-toastr";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { ComponentIdentificationService } from "../../shared/service/component-identification.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { isUndefined, isNullOrUndefined } from "util";
import { HrEmployeePassportVisaInfo } from "../../shared/models/hrEmpPassportVisaDtls";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";
import { File_Types } from "../../shared/UploadFileTypes";
import { UserService } from "../../shared/service/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import {
  VisaDialog,
  VisaDialogComponent,
} from "../../shared/components/visa-dialog/visa-dialog.component";
import { VisaTypes } from "../../shared/models/VisaTypes";
export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-passportvisa-information",
  templateUrl: "./passportvisa-information.component.html",
  styleUrls: ["./passportvisa-information.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class PassportvisaInformationComponent
  implements OnInit, OnChanges, OnDestroy {
  @Output("passportVisaDetValue") passportVisaDetValue = new EventEmitter();
  @Output("VisaDetValue") VisaDetValue = new EventEmitter();
  passportArray = this.fb.array([]);
  PassportForm: FormGroup = this.fb.group({ passport: this.passportArray });
  passportVisaDetails: any;
  visaArray: FormArray = this.fb.array([]);
  VisaForm: FormGroup = this.fb.group({ visa: this.visaArray });
  @Input() EmpId: number;
  @Input() empCode: number;
  originalPassport: any;
  originalVisa: any;
  error: any;
  result: any;
  MAX_SIZE: number = 1048576;
  parentComponentName: string;
  visaDtlsDisable: boolean = false;
  passportDtlsDisable: boolean = false;
  IsExpand = true;
  todayDate: Date;
  minDate: Date;
  approveCheckMyProfile: any;
  LoginEmpCode: any;
  disableforMyProfile: any;
  isProfile: boolean;
  visaCountries: string[] = [];
  visaTypesList: string[] = [];
  isLoader: boolean = true;
  destroyed = false;
  gettingBasicDet: any;
  hasAddPermission = false

  constructor(
    private route: ActivatedRoute,
    private _service: OnboardingService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private userService: UserService,
    private file_Svc: FileUploadService,
    private changeCom_svc: ComponentIdentificationService,
    public router: Router,
    private emp_Svc: EmployeeService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.LoginEmpCode = this.userService.getEmpCode();
    this.checkPermission();
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
      this.initializeParamChange();
    });
   // this.getSubmitMyProfileData();
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }

  checkPermission() {
    var permission = this.userService.userInfo.permissions.find(
      (i) => i.Menu === "Master"
    );
    this.hasAddPermission = permission != null ? permission.AddingPermission || permission.HasFullAccess : false;
  }

  getRefreshPage() {
    window.location.reload();
  }

  initializeParamChange() {
    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    //this.EmpId = this.LoginEmpCode;

    if (!isNullOrUndefined(this.empCode)) {
      if (this.router.url.startsWith("/myprofile/")) {
        if (this.empCode === this.LoginEmpCode) this.isProfile = true;
        else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
  }
  ngOnChanges() {
    this.getBasicEmployeeByCode().then(() => {
      this.todayDate = new Date();
      this.changeCom_svc.componentName.subscribe(
        (response) => (this.parentComponentName = response)
      );
      this.getVisaTypes();
      if (this.parentComponentName == "app-onboarding") {
        this.IsExpand = false;
      }
      if (this.parentComponentName == "app-hr-employee-details") {
        this.passportVisaDetails = new HrEmployeePassportVisaInfo();
        this.passportVisaDetails.passportDtls = [];
        this.passportVisaDetails.VisaDtls = [];
        if (!isUndefined(this.empCode)) {
          this.GetHREmpPassportVisaInfo();
        } else {
          this.getVisaCountriesByEmpCode(
            this.parentComponentName == "app-hr-employee-details"
              ? this.empCode
              : this.EmpId,
            null
          );
        }
      } else {
        this.passportVisaDetails = new OnboardEmployeePassportVisaInfo();
        this.GetPassportVisaInfo();
      }
    });
  }

  getSubmitMyProfileData() {
    this.emp_Svc
      .GetProfileVerificationStatus(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.approveCheckMyProfile = data;
        if (this.isProfile == true) {
          for (var i = 0; i < data.length; i++) {
            this.disableforMyProfile = data[i].Submitted;
          }
        }
        if (this.disableforMyProfile == true) {
          this.visaArray.disable();
          this.passportArray.disable();
        }
      });
  }

  fetchURl(url) {
    this.emp_Svc
      .getDownloadURL(url)
      .subscribe((data: any) => {
        window.open(data, '_blank');
      });
  }

  ngOnDestroy() {
    this.destroyed = true;
  }

  getObjectState() {
    const originalPassport = this.originalPassport;
    const originalVisa = this.originalVisa;
    const currentPassport = this.passportArray.value;
    const currentVisa = this.visaArray.value;
    var passportVal =
      JSON.stringify(originalPassport) === JSON.stringify(currentPassport);
    var visaVal = JSON.stringify(originalVisa) === JSON.stringify(currentVisa);
    return !(passportVal && visaVal);
  }

  GetPassportVisaInfo() {
    this._service.GetPassportVisaInfo(this.EmpId).subscribe(
      (data: any) => {
        this.visaArray = this.fb.array([]);
        this.VisaForm = this.fb.group({ visa: this.visaArray });
        this.passportArray = this.fb.array([]);
        this.PassportForm = this.fb.group({ passport: this.passportArray });
        this.getVisaCountriesByEmpCode(this.EmpId, "get");
        if (data != null) {
          this.passportVisaDetails = data;
          if (
            !isNullOrUndefined(this.passportVisaDetails.onboardPassport) &&
            this.passportVisaDetails.onboardPassport.length != 0
          ) {
            for (
              var i = 0;
              i < this.passportVisaDetails.onboardPassport.length;
              i++
            ) {
              this.addPassportItem(this.passportVisaDetails.onboardPassport[i]);
            }
          } else {
            this.addPassportItem();
          }
          if (
            !isNullOrUndefined(this.passportVisaDetails.onboardPassport) &&
            this.passportVisaDetails.onboardPassport.length != 0
          ) {
            for (
              var i = 0;
              i < this.passportVisaDetails.onboardVisas.length;
              i++
            ) {
              this.addVisaItem(this.passportVisaDetails.onboardVisas[i]);
            }
          } else {
            //this.addVisaItem();
          }
        } else {
          this.addPassportItem();
          //this.addVisaItem();
        }
        this.originalPassport = JSON.parse(
          JSON.stringify(this.passportArray.value)
        );
        this.originalVisa = JSON.parse(JSON.stringify(this.visaArray.value));
        this.EmitOutputValues();
      },
      (error) => (this.error = error)
    );
  }

  GetHREmpPassportVisaInfo() {
    if (this.empCode != null) {
      this.emp_Svc.getEmployeePassportVisaDetails(this.empCode).subscribe(
        (data: any) => {
          this.visaArray = this.fb.array([]);
          this.VisaForm = this.fb.group({ visa: this.visaArray });
          this.passportArray = this.fb.array([]);
          this.getVisaCountriesByEmpCode(this.empCode, "get");
          this.PassportForm = this.fb.group({ passport: this.passportArray });
          if (data != null) {
            this.passportVisaDetails = data;
            if (
              !isNullOrUndefined(this.passportVisaDetails.passportDtls) &&
              this.passportVisaDetails.passportDtls.length != 0
            ) {
              for (
                var i = 0;
                i < this.passportVisaDetails.passportDtls.length;
                i++
              ) {
                this.addPassportItem(this.passportVisaDetails.passportDtls[i]);
              }
            } else {
              this.addPassportItem();
            }
            if (
              !isNullOrUndefined(this.passportVisaDetails.VisaDtls) &&
              this.passportVisaDetails.VisaDtls.length != 0
            ) {
              for (
                var i = 0;
                i < this.passportVisaDetails.VisaDtls.length;
                i++
              ) {
                this.addVisaItem(this.passportVisaDetails.VisaDtls[i]);
              }
              this.cdr.detectChanges();
            } else {
              // this.addVisaItem();
            }
          } else {
            this.addPassportItem();
            // this.addVisaItem();
          }
          this.originalPassport = JSON.parse(
            JSON.stringify(this.passportArray.value)
          );
          this.originalVisa = JSON.parse(JSON.stringify(this.visaArray.value));
          this.EmitOutputValues();
        },
        (error) => (this.error = error)
      );
    }
  }

  addPassportItem(item = null) {
    if (item != null) {
      const row = this.fb.group({
        ID: item.ID,
        Country: item.Country,
        ExpiryDate: item.ExpiryDate,
        DocType: item.DocType,
        DocumentPath: item.DocumentPath,
        DocumentName: item.DocumentName,
        DocNumber: item.DocNumber,
        IssueDate: item.IssueDate,
        File: item.File,
      });
      this.passportArray.push(row);
    } else {
      const row = this.fb.group({
        ID: "",
        isCreateNew: true,
        Country: "",
        ExpiryDate: null,
        DocType: "Passport",
        DocumentPath: null,
        DocumentName: null,
        DocNumber: null,
        IssueDate: null,
        File: "",
      });
      this.passportArray.push(row);
    }
  }

  addVisaItem(item = null) {
    if (item != null) {
      const row = this.fb.group({
        ID: item.ID,
        Country: item.Country,
        CountryName: "",
        ExpiryDate: item.ExpiryDate,
        DocType: item.DocType,
        DocumentPath: item.DocumentPath,
        DocumentName: item.DocumentName,
        File: item.File,
      });
      this.visaArray.push(row);
    } else {
      var createVisa = false;
      for (var i = 0; i < this.passportArray.length; i++) {
        var passport = this.passportArray.value[i];
        if (
          (passport.Country != null &&
            passport.Country != "" &&
            passport.Country.trim() != "") ||
          passport.ExpiryDate != null ||
          passport.DocNumber != null ||
          passport.IssueDate != null ||
          passport.File != ""
        ) {
          createVisa = true;
          break;
        } else {
          createVisa = false;
          this.toastr.warning(
            "Passport information is mandatory to furnish the Visa information"
          );
        }
      }
      if (createVisa) {
        const row = this.fb.group({
          ID: "",
          isCreateNew: true,
          Country: "",
          CountryName: "",
          ExpiryDate: null,
          DocType: "",
          DocumentPath: null,
          DocumentName: null,
          File: "",
        });
        this.visaArray.push(row);
      }
    }
  }
  deleteFieldValue(index, type) {
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          if (type == "passport") {
            this.passportArray.value.splice(index, 1);
            var array = this.passportArray.value;
            this.passportArray = this.fb.array([]);
            this.PassportForm = this.fb.group({ passport: this.passportArray });
            for (var j = 0; j < array.length; j++) {
              this.addPassportItem(array[j]);
            }
          } else {
            this.visaArray.value.splice(index, 1);
            var array = this.visaArray.value;
            this.visaArray = this.fb.array([]);
            this.VisaForm = this.fb.group({ visa: this.visaArray });
            for (var i = 0; i < array.length; i++) {
              this.addVisaItem(array[i]);
            }
          }

          this.EmitOutputValues();
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  addNewVisa() {
    this.ChangeVisa();
  }

  getPassportfileName(index) {
    if (
      this.gettingBasicDet != undefined &&
      this.passportArray.value[index].DocumentName != null &&
      this.empCode != null
    ) {
      return (
        this.gettingBasicDet.EmpCode +
        "_" +
        this.gettingBasicDet.NamePerRecords +
        "_passport" +
        (index + 1)
      );
    } else if (
      this.EmpId != null &&
      this.passportArray.value[index].DocumentName != null
    ) {
      return this.gettingBasicDet.NamePerRecords + "_passport" + (index + 1);
    } else return null;
  }

  getVisafileName(index, type) {
    if (
      this.gettingBasicDet != undefined &&
      this.empCode != null &&
      this.visaArray.value[index].DocumentName != null
    ) {
      return (
        this.gettingBasicDet.EmpCode +
        "_" +
        this.gettingBasicDet.NamePerRecords +
        "_" +
        type
      );
    } else if (
      this.EmpId != null &&
      this.visaArray.value[index].DocumentName != null
    ) {
      return this.gettingBasicDet.NamePerRecords + "_" + type;
    } else return null;
  }

  getBasicEmployeeByCode() {
    return new Promise<void>((resolve, reject) => {
      if (this.empCode != null) {
        this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe(
          (data: any) => {
            this.gettingBasicDet = data;
            resolve();
          },
          (error) => {
            reject(error);
          }
        );
      } else if (this.EmpId != null) {
        this._service.getEmployeebyId(this.EmpId).subscribe(
          (data: any) => {
            this.gettingBasicDet = data;
            this.gettingBasicDet.EmpCode = this.EmpId;
            resolve();
          },
          (error) => {
            reject(error);
          }
        );
      }
    });
  }

  getVisaTypes() {
    if (this.parentComponentName == "app-hr-employee-details") {
      this.emp_Svc.getVisaTypes().subscribe((data: any) => {
        this.visaTypesList = data;
      });
    } else {
      this._service.getVisaTypes().subscribe((data: any) => {
        this.visaTypesList = data;
      });
    }
  }

  ChangeVisa() {
    const message = `Add New Visa`;
    const dialogData = new VisaDialog(
      "Action",
      message,
      this.parentComponentName
    );
    const dialogRef = this.dialog.open(VisaDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getVisaTypes();
          this.VisaForm.get("DocType").setValue("");
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }
  getVisaCountriesByEmpCode(empCode, type) {
    if (this.parentComponentName == "app-hr-employee-details") {
      if (this.empCode != null) {
        this.emp_Svc.getVisaCountryByEmpCode(empCode).subscribe((data: any) => {
          this.visaCountries = data;
          if (type && !this.destroyed) {
            this.cdr.detectChanges();
          }
        });
      }
    } else {
      if (empCode != null) {
        this._service
          .getVisaCountryByEmpCode(empCode)
          .subscribe((data: any) => {
            this.visaCountries = data;
            if (type && !this.destroyed) {
              this.cdr.detectChanges();
            }
          });
      }
    }
  }

  handleFileInput(event, index: number, type) {
    if (event.target.files == undefined) {
      type == "passport"
        ? (this.passportArray.value[index].File = null)
        : (this.visaArray.value[index].File = null);
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      // Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        type == "passport"
          ? (this.passportArray.value[index].File =
            this.file_Svc.readAndUploadFile(files))
          : (this.visaArray.value[index].File =
            this.file_Svc.readAndUploadFile(files));
        if (type == "passport") {
          this.passportArray.value[index].DocumentPath = null;
          this.passportArray.at(index).patchValue({
            DocumentPath: null,
          });
        } else {
          this.visaArray.value[index].DocumentPath = null;
          this.visaArray.at(index).patchValue({
            DocumentPath: null,
          });
        }
        this.cdr.detectChanges();
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
  }
  EmitOutputValues() {
    this.passportVisaDetValue.emit(this.passportArray);
    this.VisaDetValue.emit(this.visaArray);
  }

  //Check the file types
  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }
  setPassportExpiryDate(issueDate: Date) {
    //alert(issueDate);
    const fromIssueDate = new Date(issueDate);
    //alert(fromIssueDate);
    const fromYear = fromIssueDate.getFullYear();
    const fromMonth = fromIssueDate.getMonth();
    const fromDate = fromIssueDate.getDate();
    this.minDate = new Date(fromYear, fromMonth, fromDate + 1);
  }
}
